 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-fab_3-ios-entry-js","22":"stencil-ion-fab_3-md-entry-js","23":"stencil-ion-img-entry-js","24":"stencil-ion-infinite-scroll_2-ios-entry-js","25":"stencil-ion-infinite-scroll_2-md-entry-js","26":"stencil-ion-input-ios-entry-js","27":"stencil-ion-input-md-entry-js","28":"stencil-ion-loading-ios-entry-js","29":"stencil-ion-loading-md-entry-js","30":"stencil-ion-popover-ios-entry-js","31":"stencil-ion-popover-md-entry-js","32":"stencil-ion-progress-bar-ios-entry-js","33":"stencil-ion-progress-bar-md-entry-js","34":"stencil-ion-radio_2-ios-entry-js","35":"stencil-ion-radio_2-md-entry-js","36":"stencil-ion-reorder_2-ios-entry-js","37":"stencil-ion-reorder_2-md-entry-js","38":"stencil-ion-ripple-effect-entry-js","39":"stencil-ion-spinner-entry-js","40":"stencil-ion-split-pane-ios-entry-js","41":"stencil-ion-split-pane-md-entry-js","42":"stencil-ion-tab-bar_2-ios-entry-js","43":"stencil-ion-tab-bar_2-md-entry-js","44":"stencil-ion-tab_2-entry-js","45":"stencil-ion-text-entry-js","46":"stencil-ion-textarea-ios-entry-js","47":"stencil-ion-textarea-md-entry-js","48":"stencil-ion-toggle-ios-entry-js","49":"stencil-ion-toggle-md-entry-js","50":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"56b57e5c","1":"6a873736","2":"234bb410","3":"59e1b536","4":"6342ebb7","5":"3b92f5fa","8":"6204b7e5","9":"dc03d0a7","10":"c880a516","11":"c44aba15","12":"73214fc6","13":"ce4a4843","14":"5435b6d7","15":"9a39990e","16":"df8f0b4b","17":"1c46d2b7","18":"7c5e41b6","19":"d7b3b0c9","20":"3eb8646a","21":"c6790b08","22":"8774301f","23":"1b820632","24":"003180e1","25":"fb68bd05","26":"bcb16d0a","27":"a615d0f9","28":"7a9bf063","29":"0e0249e0","30":"26e8ad92","31":"2b67dfe0","32":"263f5101","33":"3b1d4274","34":"73192714","35":"9c456542","36":"cadbd025","37":"63ceb0ae","38":"4585655e","39":"2a6ef668","40":"bc1cc0fa","41":"5db10788","42":"127deb7c","43":"d9f93527","44":"86bee943","45":"41598cab","46":"f4fd23c9","47":"74501a10","48":"41dddd9b","49":"d46d2125","50":"1ea2bee4","52":"450bf762","53":"c6f4ed11","54":"e4b76b3f","55":"fbb4744d","56":"21a58cb8","57":"6ad2532f","58":"a059ff6b","59":"76ecbbed","60":"0d092590","61":"cdd71515","62":"17baf933","63":"46a9f77a","64":"447a83ed","65":"21d2be9b","66":"c4fb4896","67":"17248803","68":"f43bf39a","69":"23cf29af","70":"21803dee","71":"a3fdbfc4","72":"8979a74a","73":"943f660c","74":"37a0ec8d","75":"512fc791","76":"763a529e","77":"c6088dec","78":"1c7f6b00","79":"45bda2b8","80":"e871e91f","81":"460bd6d9","82":"60cacc36","83":"8eb9ab83","84":"7e5c7070","85":"70fe691e","86":"98f7fac4","87":"82aaf5a5","88":"bde20a82","89":"f97cf144","90":"1fee0eb4","91":"c62275b2"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpNewsy"] = this["webpackJsonpNewsy"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
